import { Divider, Grid, makeStyles, MenuItem, Typography } from "@material-ui/core"
import { DatePicker } from "@ofqual/portal-components/components/DatePicker";
import { Select } from "@ofqual/portal-components/components/Select"
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { Model, QueryParams } from "@ofqual/portal-core/core/types"
import { directorateLookupService, lcmPolicyProjectCategoryService, lcmPolicyProjectSubCategoryService, matterTypeLookupService, usersService } from "../../services";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { authSelector } from "../../redux/selectors";

const useStyles = makeStyles(() => ({
  sectionHeading: {
    marginTop: 20,
    marginBottom: 20
  },
}));

export const LcmFilter: React.FC<{ workingParams: QueryParams, addParam: (name: string, value: string | number | string[] | number[] | undefined) => void }> =
  ({ workingParams, addParam }) => {
    const classes = useStyles();
    const { token } = useSelector(authSelector);
    const [upns, setUpns] = useState([] as Model[]);

    const [
      direcorateLookups,
      matterTypeLookups,
      projectCategoryLookups,
      projectSubCategoryLookups
    ] = useLookup(
      directorateLookupService,
      matterTypeLookupService,
      lcmPolicyProjectCategoryService,
      lcmPolicyProjectSubCategoryService
    );

    useEffect(() => {
      usersService.getUsers({ token }).then((response) => setUpns(response));
    }, [token]);

    return (
      <>
        <Divider />
        <Grid xs={12} container justifyContent="center">
          <Grid item xs={11}>
            <Typography variant="h6" className={classes.sectionHeading}>LCM notifications</Typography>
          </Grid>
        </Grid>
        <MenuItem>
          <Select
            label="LCM Directorate"
            data-test="notification-types-filter"
            value={workingParams.lcmDirectorate}
            onChange={(e) => addParam("lcmDirectorate", e.target.value)}
          >
            {direcorateLookups}
          </Select>
        </MenuItem>
        <MenuItem>
          <DatePicker
            label="Created date:"
            value={workingParams.lcmCreatedDate || null}
            onChange={(val) => {
              console.log('Date is: ', val);
              if (val === null) {
                addParam("lcmCreatedDate", undefined);
              } else {
                addParam("lcmCreatedDate", val);
              }
            }}
            returnDayBoundary="endOfDay"
            clearable
          />
        </MenuItem>
        <MenuItem>
          <Select
            label="Matter type"
            data-test="notification-types-filter"
            value={workingParams.lcmMatterType}
            onChange={(e) => addParam("lcmMatterType", e.target.value)}
          >
            {matterTypeLookups}
          </Select>
        </MenuItem>
        <MenuItem>
          <Autocomplete
            fullWidth
            autoSelect
            options={upns}
            ChipProps={{ color: "primary" }}
            renderInput={(params) => (
              <TextField
                {...params}
                data-test="int-msg-recipient-field"
                name="lcmAssignedTo"
                variant="outlined"
                label="Assigned to"
              />
            )}
            getOptionLabel={(option: any) => option.name}
            getOptionSelected={(option: any, value) => option.id === value}
            onChange={(e: any, data: any) => {
              if (data !== null) {
                addParam("lcmAssignedTo", data.name)
              }
            }}
          />
        </MenuItem>
        <MenuItem>
          <Select
            label="Policy category"
            data-test="notification-types-filter"
            value={workingParams.lcmPolicyCategory}
            onChange={(e) => addParam("lcmPolicyCategory", e.target.value)}
          >
            {projectCategoryLookups}
          </Select>
        </MenuItem>
        <MenuItem>
          <Select
            label="Policy sub-category"
            data-test="notification-types-filter"
            value={workingParams.lcmPolicySubCategory}
            onChange={(e) => addParam("lcmPolicySubCategory", e.target.value)}
          >
            {projectSubCategoryLookups}
          </Select>
        </MenuItem>
      </>
    )
  }